const MiniHeader = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-[40px] bg-[#f9fafb] border-b border-gray-200 z-50 overflow-hidden">
      <div className="h-full flex items-center">

        <div className="whitespace-nowrap animate-marquee text-sm font-bold text-red-600 px-6">
          स्वागत है बुंदेली चुगली एवं हिंदी चुगली में — बुंदेलखंड की सच्ची और ज़मीनी खबरें आपके लिए
        </div>

      </div>
    </div>
  );
};

export default MiniHeader;
